<template>
  <v-card class="pa-5">
    <div class="d-flex">
      <div class="text-right" style="flex: 0 0 auto">
        <v-icon color="icon" style="font-size:54px">
          mdi-file-document
        </v-icon>
      </div>
      <v-divider vertical class="mx-6"/>
      <div style="flex: 1 1 auto">
        <template v-if="isNewCaseFiling">
          <div class="c-caption" style="font-size:1.3rem">
            {{ $t('page.manageFiling.docketEntry.splash.newCase.title') }}
          </div>
          <div class="font-weight-light" style="font-size: 1.35rem;max-width:80ch">
            {{ $t('page.manageFiling.docketEntry.splash.newCase.description') }}
          </div>
          <div class="mt-10">
            <c-btn v-if="!isLeadComplete" large type="primary" style="min-width:160px" @click="$emit('startLead')">
              {{ $t('page.manageFiling.docketEntry.button.enterInfo') }}
            </c-btn>
            <c-btn v-if="isLeadComplete" large type="primary" style="min-width:160px" @click="$emit('viewDocketEntries')">
              {{ $t('page.manageFiling.docketEntry.button.viewDocketEntries') }}
            </c-btn>
          </div>
        </template>
        <template v-else>
          <div class="c-caption" style="font-size:1.3rem">
            {{ $t('page.manageFiling.docketEntry.splash.existingCase.title') }}
          </div>
          <div class="font-weight-light" style="font-size: 1.35rem;max-width:80ch">
            {{ $t('page.manageFiling.docketEntry.splash.existingCase.description') }}
          </div>
          <div class="mt-10">
            <c-btn v-if="!isLeadComplete" large type="primary" style="min-width:160px" @click="$emit('startLead')">
              {{ $t('page.manageFiling.docketEntry.button.enterInfo') }}
            </c-btn>
            <c-btn v-if="isLeadComplete" large type="primary" style="min-width:160px" @click="$emit('viewDocketEntries')">
              {{ $t('page.manageFiling.docketEntry.button.viewDocketEntries') }}
            </c-btn>
          </div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import { useFilingStore } from '@/stores/filingStore';

const filingStore = useFilingStore();

export default {
  props: {
    isLeadComplete: {
      type: Boolean
    }
  },
  computed: {
    isNewCaseFiling () {
      return filingStore.isNewCaseFiling;
    }
  }
};
</script>